<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户充值</el-breadcrumb-item>
    </el-breadcrumb>





    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"

      ref="multipleTable"
    >
        <el-table-column  label="用户">
            <template slot-scope="scope">
                {{ scope.row.username}}
            </template>
        </el-table-column>

      <el-table-column prop="money" label="金额">
        <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
      </el-table-column>

      <el-table-column prop="money" label="申请日期">
        <template slot-scope="scope">
          {{ scope.row.add_time }}
        </template>
      </el-table-column>
        <el-table-column prop="money" label="核准日期">
            <template slot-scope="scope">
                {{ scope.row.end_time }}
            </template>
        </el-table-column>
        <el-table-column prop="money" label="状态">
            <template slot-scope="scope">
                <span v-if="scope.row.state==0">待审批</span>
                <span v-if="scope.row.state==-1">未批准</span>
                <span v-if="scope.row.state==1">审批</span>

            </template>
        </el-table-column>
        <el-table-column prop="money" label="状态">
            <template slot-scope="scope">
                <el-button type="primary" @click="confirm(scope.row)" v-if="scope.row.state==0"
                >审批</el-button
                >

            </template>
        </el-table-column>



    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    data() {
        return {


            page: 1,
            user_id: 0,
            formContent: false

        };
    },
    methods: {
        ...mapActions({
            getUserRechargeAction: "getUserRechargeAction",
            addExamineAction: "addExamineAction",

        }),


        confirm(row) {

            this.$confirm('用户充值审批, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.addExamine(row.id,row.money)
                // this.$message({
                //     type: 'success',
                //     message: '用户充值审批成功!'
                // });
            })

            console.log(row)


        },
        addExamine(id, money) {


            this.addExamineAction({
                id: id,
                money: money,


            });
        },

        changePage(e) {
            this.page = e;
            this.changePageData(e);
        },
        changePageData(page) {
            this.page = page;

            this.getUserRechargeAction({page: page});
        },
        getPageData() {
            this.getUserRechargeAction({
                page: this.page,
            });
        },
    },

    mounted() {
        this.getPageData()
    },
    //tableData
    computed: mapState({
        tableData: (state) => state.recharge.result,
        examineData: (state) => state.examine.result,
    }),

    watch: {
        examineData(newdata) {

            if (newdata.code == 301) {
                this.$message({
                    message: "金额审批成功",
                    type: "success",
                });
                this.getPageData()
            }

        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
